export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"ErrorCreateConsultation": "Der opstod en fejl under oprettelse af konsultationen",
	"ErrorSendMessage": "Der opstod en fejl under afsendelse af beskeden",
	"Today": "I dag",
	"ErrorFieldIsMandatory": "Feltet skal udfyldes",
	"ConversationInProgress": "Samtale i gang",
	"IsEmployee": "(medarbejder)",
	"ConversationStartedInfo": "Ankom for {0} siden",
	"ErrorInvalidEmail": "Angiv venligst en gyldig e-mail.",
	"ErrorInvalidCpr": "Ugyldigt CPR-nummer",
	"Tomorrow": "I morgen",
	"ErrorEmailAndOrPhone": "Angiv venligst e-mail og/eller telefonnummer",
	"ErrorUnknown": "Der opstod en ukendt fejl",
	"NameMustBeFilled": "Navn skal udfyldes",
	"NameMustOnlyContainLetters": "Navnet må kun indeholde bogstaver"
}